module.exports = __webpack_public_path__ + "img/rice.be5030ca.webp";